import React from 'react';
import { useNavigate } from 'react-router-dom';
import Services from '../../Services/services';

function QuotesModal(props) {
	const navigate = useNavigate();

	const validateExpert = async () => {
		let onError = false;
		try {
			await props.selectExpert();
		} catch (error) {
			onError = true;
			console.error(error);
		}

		if (onError) return;

		try {
			await Services.emailService.sendClientChoseExpert(
				props?.expert?.user?.email,
				'CEC : Un client vous a envoyé une demande pour un devis',
				props?.expert?.firstName,
				props?.expert?.lastName
			);
		} catch (error) {
			console.error(error);
		}

		props.setShowModal(false);
		navigate('/waiting-acceptations');
	};

	return (
		<div className="container-modal">
			<div
				className="background-modal"
				onClick={(e) => props.closeModal(e)}
			></div>
			<div className="modal">
				<div className="modal-expert-title">
					Êtes-vous sure de vouloir sélectionner cet expert ?
				</div>
				<div className="modal-expert-detail">
					En confirmant votre choix, vous consentez à la transmission de vos
					données à l'expert-comptable sélectionné afin qu'il vous propose des
					rendez-vous. CEC vous fournit une estimation de prix, qui n'est en
					aucun cas définitive.
					<br />
					Le coût final est susceptible de varier après votre rendez-vous avec
					l'expert-comptable.
				</div>
				<div className="choose-expert" onClick={validateExpert}>
					Confirmer mon choix
				</div>
				<div
					className="forward-modal"
					onClick={() => props.setShowModal(false)}
				>
					Annuler
				</div>
			</div>
		</div>
	);
}

export default QuotesModal;
